import React, { useContext, useEffect, useState } from 'react'
import { useLocation, useNavigate } from "react-router-dom";
import img1 from "../dist/webImages/dropdown.svg"
import HeaderProfile from './HeaderProfile'
import { FaArrowLeft, FaGlobe } from 'react-icons/fa'
import { FiBell } from "react-icons/fi";
import { MainMenuActiveContext } from '../context/MainMenuActiveContext'
import { MainLanguageContext } from '../context/MainLanguageContext'

const Header = () => {
  const { handlelanguage, mainLanguage } = useContext(MainLanguageContext);
  const { handleGetEditValue } = useContext(MainMenuActiveContext);
  const [handlemenu, setHandleMenu] = useState(false);

  const location = useLocation();
  const navigate = useNavigate();
  const path = location.pathname;

  const moduleNames = {
    "/": "Dashboard",
    "/profile": "Profile",
    "/booking": "Booking",
    "/users": "Users",
    "/users/create": "Create User",
    "/role": "Roles",
    "/role/create": "Create Role",
    "/catalogs": "Catalogs",
    "/catalogs/create": "Create Catalog",
    "/carwithdrivers": "Car With Drivers",
    "/products": "Products",
    "/products/create": "Create Product",
    "/promo": "Promo Codes",
    "/promotions": "Promotions",
    "/promotions/create": "Promotions Create",
    "/partners": "Partners",
    "/blogs": "Blogs",
    "/testimonials": "Testimonials",
    "/testimonials/create": "Testimonials Create",
    "/webcontent": "Web Content",
    "/webcontent/about-us": "About Us",
    "/webcontent/contact-us": "Contact Us",
    "/webcontent/faqs": "FAQs",
    "/webcontent/our-blogs": "Our Blogs",
    "/webcontent/partners": "Our Partners",
    "/lead": "Enquiries",
    "/quote": "Quote",
    "/setting": "Settings",
    "/products/properties": "Products Properties",
    "/products/coverages": "Products Coverages",
    "/blogs/create": "Blogs Create",
    "/products/properties/create": "Products Properties Create",
    "/products/coverages/create": "Products Coverages Create",
    "/partners/create": "Partners Create",
    "/promo/create": "Promo Create",
    "/webcontent/home": "Home",
    "/webcontent/testimonials": "Testimonials",
    "/webcontent/promotions": "Promotions",
    "/webcontent/product-inner": "Product Inner",
    "/webcontent/corporatelease": "Corporate Lease",
    "/webcontent/lease-to-own-page": "Lease To Own Page",
    "/webcontent/vehicle-listing": "Vehicle Listing",
    "/webcontent/vehicle-booking": "Vehicle Booking",
    "/webcontent/thank-you": "Thank You",
    "/webcontent/term-and-conditions": "Terms and Conditions",
    "/webcontent/privacy-policy": "Privacy Policy",
    "/webcontent/testimonials-video": "Testimonials Video",
    "/webcontent/our-locations": "Our Locations",
    "/webcontent/franchise": "Franchise",
    "/webcontent/flexible": "Flexible Rental",
    "/webcontent/finalize": "Finalize",
  };

  let currentModule = moduleNames[path];

  if (!currentModule) {
    const dynamicRoutes = [
      { prefix: "/users/edit/", name: "Edit User" },
      { prefix: "/role/edit/", name: "Edit Role" },
      { prefix: "/catalogs/edit/", name: "Edit Catalog" },
      { prefix: "/carwithdrivers/edit/", name: "Edit Car With Driver" },
      { prefix: "/products/edit/", name: "Edit Product" },
      { prefix: "/products/properties/edit/", name: "Edit Product Property" },
      { prefix: "/products/coverages/edit/", name: "Edit Product Coverage" },
      { prefix: "/promo/edit/", name: "Edit Promo Code" },
      { prefix: "/promotions/edit/", name: "Edit Promotion" },
      { prefix: "/partners/edit/", name: "Edit Partner" },
      { prefix: "/blogs/edit/", name: "Edit Blog" },
      { prefix: "/testimonials/edit/", name: "Edit Testimonial" },
      { prefix: "/webcontent/", name: "Web Content Page" },
    ];

    const match = dynamicRoutes.find((route) => path.startsWith(route.prefix));
    currentModule = match ? match.name : "Module";
  }

  return (
    <div className='header py-2 border-b shadow-[0_0_35px_0_#ddd] border-[#ddd] px-4 flex justify-between items-center max-lg:pr-6'>
      <div className="flex items-center gap-2">
        {path !== "/" && (
          <button
            onClick={() => navigate(-1)}
            className="text-black text-[1.4rem]"
          >
            <FaArrowLeft />
          </button>
        )}
        <h2 className="font-semibold text-[2rem] font-Cinzel text-primary ">
          {currentModule}
        </h2>
      </div>
      <div className="header__right flex items-center gap-4">
        <div className="inputBox border border-[#ddd] rounded-full relative">
          <input type="text" className='rounded-full placeholder:text-black px-4 w-[10rem] py-2 focus:outline-none' placeholder='Search' />
        </div>
        <div className="inputBox relative languages mt-[8px]">
          <button onClick={() => setHandleMenu(!handlemenu)} >
            <FiBell className='text-[1.6rem] text-black' />
          </button>
          <ul className={`absolute h-[20rem] z-[11] mt-6 bg-white shadow-[0_0_35px_0_#ddd] w-[20rem] rounded-[20px] transition-all duration-300 right-0 max-[1024px]:right-[-5rem] p-4 ${handlemenu ? 'block' : 'hidden'}`}>
            <div className='text-center font-semibold text-[1.5rem]'>Notification</div>
          </ul>
        </div>
        <div className="inputBox relative languages ">
          <FaGlobe className='text-[1.5rem] text-black' onClick={() => handleGetEditValue(true)} />
          <select value={mainLanguage} onChange={(e) => handlelanguage(e.target.value)} className={`w-full absolute bg-transparent text-transparent inset-0 p-2 rounded-3xl outline-0 capitalize appearance-none max-lg:text-[.9rem]`} name="" id="">
            <option className='text-black' value="en">English</option>
            <option className='text-black' value="ar">Arabic</option>
            {/* <option value="ru">Russian</option>
                <option value="ch">Chinese</option> */}
          </select>
        </div>
        <div className='profile flex items-center gap-4'>
          <HeaderProfile />
        </div>
      </div>
      {/* close header__right  */}
    </div>
  )
}

export default Header
